import { OrganizationProductType, Product } from "generated/graphql";
import DeleteProductMenuItem from "./DeleteProductMenuItem";
import UpdateProductMenuItem from "./UpdateProductMenuItem";

export default function ProductMenuItems({
  id,
  productTypeId,
  closeMenu,
}: {
  id: Product["id"];
  productTypeId: OrganizationProductType["id"];
  closeMenu: () => void;
}) {
  return (
    <>
      <UpdateProductMenuItem closeMenu={closeMenu} id={id} productTypeId={productTypeId} />
      <DeleteProductMenuItem closeMenu={closeMenu} id={id} />
    </>
  );
}
